
Array.prototype.forEach.call(document.getElementsByClassName('add-twx-button'), (element, i) => {
    element.addEventListener("click", () => {
        const selectedVarID = element.parentElement.querySelector(".twx-product-variants").value;
        if (selectedVarID) {
            const formData = {
                'items': [{
                    'id': parseInt(selectedVarID),
                    'quantity': 1,
                }]
            };
            event.preventDefault()
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            })
                .then(response => {
                    window.location.assign('/cart');
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    });
});

function initMerchSwiper() {
  if (window.mensSwiper && typeof window.mensSwiper.destroy === 'function') {
    window.mensSwiper.destroy(true, true);
  }
  
  window.mensSwiper = new Swiper('.merch-products-swiper__wrapper-mens', {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 10,
    allowTouchMove: true,
    loop: true,
    loopFillGroupWithBlank: false,
    navigation: {
      nextEl: '.mens-single-swiper-button-prev',
      prevEl: '.mens-single-swiper-button-next'
    },
    breakpoints: {
      600: {
        slidesPerView: 2,
        spaceBetween: 10,
        allowTouchMove: true
      },
      800: {
        slidesPerView: 3,
        spaceBetween: 30,
        allowTouchMove: false
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
        allowTouchMove: false
      },
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const merchSwiperContainer = document.querySelector('.cart-merch-swiper__container');
  
  if (merchSwiperContainer) {
    if (window.getComputedStyle(merchSwiperContainer).display !== 'none') {
      initMerchSwiper();
    }
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'style' || mutation.attributeName === 'class') {
          const display = window.getComputedStyle(merchSwiperContainer).display;
          if (display !== 'none') {
            setTimeout(initMerchSwiper, 50);
          }
        }
      });
    });
    
    observer.observe(merchSwiperContainer, { 
      attributes: true,
      attributeFilter: ['style', 'class'] 
    });
  }
});

